import type { TextStyle } from 'react-native'

/** @see {@link https://github.com/facebook/react-native/issues/7687#issuecomment-220886890} */
export function safeLineHeight(unsafeLineHeight: NonNullable<TextStyle['lineHeight']>) {
  const lineHeight = unsafeLineHeight * 2
  const extraSpace = (unsafeLineHeight - lineHeight) / 2
  return {
    lineHeight,
    marginTop: extraSpace,
    marginBottom: extraSpace,
  } as const satisfies TextStyle
}
